import { render, staticRenderFns } from "./ConfirmStickerParams.vue?vue&type=template&id=5a2e4a8f&scoped=true"
import script from "./ConfirmStickerParams.vue?vue&type=script&lang=js"
export * from "./ConfirmStickerParams.vue?vue&type=script&lang=js"
import style0 from "./ConfirmStickerParams.vue?vue&type=style&index=0&id=5a2e4a8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e4a8f",
  null
  
)

export default component.exports